import { useGetArtifactPreviewUrl, useGetArtifactRevisionPreviewUrl } from '@/api/artifact.hook'
import { DocumentQuote } from '@/gen/artifacts/v1/model_pb'

export const useSourceDocument = (documentQuote?: DocumentQuote) => {
  const { quote } = documentQuote || {}

  let id: string | undefined
  let fallbackLink: string | undefined
  switch (quote?.case) {
    case 'orgArtifactId':
      id = quote.value
      break
    case 'artifact':
      id = quote.value.id
      fallbackLink = quote.value.url
      break
  }

  const { data: orgArtifactData, isLoading: isOrgArtifactLoading } = useGetArtifactPreviewUrl(
    id ?? '',
    quote?.case === 'orgArtifactId',
  )
  const { data: artifactRevisionData, isLoading: isArtifactRevisionLoading } =
    useGetArtifactRevisionPreviewUrl(id ?? '', quote?.case === 'artifact')

  const link = orgArtifactData?.url ?? artifactRevisionData?.url
  const isLoading = isOrgArtifactLoading || isArtifactRevisionLoading

  return { link, fallbackLink, isLoading }
}
